import { ReactNode, useEffect, useState } from "react";

export function InfiniteScrollContainer({
  children,
  id,
}: {
  children: ReactNode;
  id: string;
}) {
  const [deferredRender, setDeferredRender] = useState(false);

  useEffect(() => {
    setDeferredRender(true);
  }, []);

  if (!deferredRender) {
    return null;
  }

  return (
    <div
      id={id}
      className={
        "h-[56dvh] xl:h-[60dvh] overflow-y-auto overflow-x-hidden overscroll-contain"
      }
    >
      {children}
    </div>
  );
}
